var simulator = {
    oBut: '',
    aLi: '',
    iNow: 9,
    timer: null,
    tt: null,
    aSort: [],
    aPosition: [
        {width:276,height:214,top:0,left:317,zIndex:10},
        {width:212,height:170,top:22,left:212,zIndex:8},
        {width:128,height:128,top:43,left:145,zIndex:6},
        {width:88,height:88,top:66,left:265,zIndex:4},
        {width:88,height:88,top:66,left:265,zIndex:4},
        {width:88,height:88,top:66,left:603,zIndex:4},
        {width:88,height:88,top:66,left:603,zIndex:4},
        {width:88,height:88,top:66,left:603,zIndex:4},
        {width:128,height:128,top:43,left:641,zIndex:6},
        {width:212,height:170,top:22,left:490,zIndex:8}
    ],
    Init: function(){
        var that = this;

        that.oBut = document.getElementById('list');
        that.aLi = that.oBut.getElementsByTagName('li');

        for(var i=0; i<that.aLi.length; i++){
            that.aLi[i].index = i;
            that.aLi[i].style.width = that.aPosition[i].width +'px';
            that.aLi[i].style.height = that.aPosition[i].height +'px';
            that.aLi[i].style.top = that.aPosition[i].top +'px';
            that.aLi[i].style.left = that.aPosition[i].left +'px';
            that.aLi[i].style.zIndex = that.aPosition[i].zIndex;
            that.aSort[i] = that.aPosition[i];
        }
    },
    Start: function(success, collback){
        var that = this;
        var speed = 300;
        var res = 9 - success;
        var round = 29 +  res;
        setTimeout(fun, speed);
        function fun(){
            that.setInter();
            speed = speed > 100 ? speed-29: 100;
            if(round >0) {
                setTimeout(fun, speed);
            }else{
                that.aLi[9-res].className += ' hove';
                setTimeout(collback, 800);

                setTimeout(function(){
                    for(var j=0; j<success; j++){
                        that.setInter();
                    }
                    that.iNow = 9;
                }, 1000);
            }
            round --;
        }
        
    },
    setInter: function (){
        this.iNow--;
        if(this.iNow < 0) this.iNow = 9;

        this.tab();
    },
    tab: function (){
        var iSort = this.iNow;
        this.Sort();
        for(var i=0;i<iSort;i++){
            this.aSort.unshift(this.aSort.pop());
        }
        this.sMove();
    },
    Sort: function (){
        for(var i=0;i<this.aLi.length;i++){
            this.aSort[i] = this.aPosition[i];
        }
    },
    sMove: function (){
        for(var i=0;i<this.aLi.length;i++){
            this.startMove(this.aLi[i], this.aSort[i]);
        }
        
    },
    startMove: function (obj, json, fnEnd){
        var that = this;
        if(obj.timer) clearInterval(obj.timer);

        obj.timer = setInterval(function (){
            that.doMove(obj, json, fnEnd);
        }, 30);
        
    },
    getStyle: function (obj, attr){
        return getComputedStyle(obj, false)[attr];
    },
    doMove: function (obj, json, fnEnd){
        var that = this;
        var iCur = 0;
        var attr = '';
        var bStop = true;
        for(attr in json){
            iCur = parseInt(that.getStyle(obj, attr));
            if(navigator.userAgent.indexOf("MSIE 8.0") > 0){
                var iSpeed = (json[attr]-iCur) / 3;
            }else{
                var iSpeed = (json[attr]-iCur) / 5;
            }
            iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
            if(parseInt(json[attr])!=iCur)bStop = false;
            attr == 'zIndex' ? obj.style[attr] = iCur + iSpeed : obj.style[attr] = iCur + iSpeed +'px';
        }
        if(bStop){
            clearInterval(obj.timer);
            obj.timer = null;       
            if(fnEnd)fnEnd();
        }
    }
};
simulator.Init();

module.exports = simulator;

